var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWithdraw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 89 27.582 H 71.336 c -0.553 0 -1 -0.448 -1 -1 s 0.447 -1 1 -1 H 88 V 4.45 H 2 v 21.132 h 16.664 c 0.552 0 1 0.448 1 1 s -0.448 1 -1 1 H 1 c -0.552 0 -1 -0.448 -1 -1 V 3.45 c 0 -0.552 0.448 -1 1 -1 h 88 c 0.553 0 1 0.448 1 1 v 23.132 C 90 27.134 89.553 27.582 89 27.582 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.289 66.499 H 25.864 c -0.552 0 -1 -0.447 -1 -1 V 20.898 c 0 -0.552 0.448 -1 1 -1 s 1 0.448 1 1 v 43.601 h 21.425 c 0.553 0 1 0.447 1 1 S 48.842 66.499 48.289 66.499 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 64.136 45.674 c -0.553 0 -1 -0.448 -1 -1 V 20.898 c 0 -0.552 0.447 -1 1 -1 s 1 0.448 1 1 v 23.776 C 65.136 45.226 64.688 45.674 64.136 45.674 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 78.679 16.016 H 11.322 c -0.552 0 -1 -0.448 -1 -1 s 0.448 -1 1 -1 h 67.357 c 0.553 0 1 0.448 1 1 S 79.231 16.016 78.679 16.016 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 38.721 c -5.093 0 -9.236 -4.144 -9.236 -9.236 c 0 -5.093 4.144 -9.237 9.236 -9.237 s 9.236 4.144 9.236 9.237 C 54.236 34.577 50.093 38.721 45 38.721 z M 45 22.248 c -3.99 0 -7.236 3.247 -7.236 7.237 S 41.01 36.721 45 36.721 s 7.236 -3.246 7.236 -7.236 S 48.99 22.248 45 22.248 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 78.679 74.206 h -2.034 c 0.314 -3.089 0.775 -5.823 1.231 -8.455 c 0.918 -5.31 1.712 -9.895 0.895 -15.591 c -0.551 -3.838 -3.126 -7.108 -6.678 -8.515 l -2.921 -1.32 c -0.505 -0.228 -1.096 -0.003 -1.323 0.5 s -0.004 1.096 0.499 1.323 l 2.965 1.338 c 2.93 1.162 5.029 3.828 5.478 6.958 c 0.773 5.384 0.005 9.825 -0.885 14.967 c -0.472 2.725 -0.95 5.555 -1.27 8.796 h -20.8 c 0.821 -4.102 2.755 -7.767 5.542 -10.404 c 0.198 -0.188 0.312 -0.449 0.313 -0.723 s -0.109 -0.535 -0.307 -0.725 l -6.195 -5.959 c -0.482 -0.422 -1.035 -0.738 -1.641 -0.941 c -0.041 -0.014 -0.083 -0.025 -0.126 -0.033 l -6.166 -1.203 c -1.978 -0.694 -3.11 -2.744 -2.637 -4.794 l 0.19 -0.826 c 0.48 -2.085 2.506 -3.463 4.692 -3.128 l 5.957 0.519 c 0.423 0.065 0.832 0.229 1.179 0.471 l 11.486 8.092 c 0.454 0.318 1.076 0.21 1.394 -0.241 c 0.318 -0.452 0.21 -1.075 -0.241 -1.394 l -11.491 -8.095 c -0.6 -0.418 -1.299 -0.698 -2.087 -0.817 l -5.957 -0.519 c -3.142 -0.487 -6.166 1.563 -6.88 4.663 l -0.19 0.826 c -0.709 3.078 1.014 6.156 4.009 7.16 c 0.042 0.014 0.083 0.025 0.126 0.033 l 6.165 1.202 c 0.332 0.119 0.633 0.296 0.867 0.499 l 5.426 5.221 c -2.776 2.935 -4.676 6.825 -5.462 11.116 h -2.339 c -0.553 0 -1 0.447 -1 1 v 11.345 c 0 0.553 0.447 1 1 1 h 29.218 c 0.553 0 1 -0.447 1 -1 V 75.206 C 79.679 74.653 79.231 74.206 78.679 74.206 z M 77.679 85.551 H 50.461 v -9.345 h 27.218 V 85.551 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/withdraw.f0514675d3773d06ade3696fdca64231.svg";
export { ForwardRef as ReactComponent };